

// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   Button,
//   Space,
//   Image,
//   Popconfirm,
//   message,
//   Card,
//   Tag,
//   Modal,
//   Descriptions,
//   Layout,
//   Typography,
//   Progress,
//   Tooltip,
// } from "antd";
// import {
//   EditOutlined,
//   DeleteOutlined,
//   EyeOutlined,
//   CheckCircleFilled,
//   CloseCircleFilled,
//   LoadingOutlined,
//   CrownOutlined,
//   UploadOutlined,
//   MenuOutlined,
//   ShareAltOutlined,
// } from "@ant-design/icons";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "../Components/Sidebar";
// import { BASE_URL } from "../Config";
// import axios from "axios";
// import ErrorPopup from "../Components/popup/ErrorPopup";
// import SuccessPopup from "../Components/popup/SuccessPopup";
// import PromotionPopup from "../Components/popup/PromotionPopup/PromotionPopup";
// import PaymentModal from "../Components/PaymentModal";
// import FreeExtensionModal from "../Components/FreeExtensionModal";

// const { Header } = Layout;
// const { Text } = Typography;

// const MyVariations = () => {
//   const [data, setData] = useState([]);
//   const [collapsed, setCollapsed] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [viewModalOpen, setViewModalOpen] = useState(false);
//   const [viewData, setViewData] = useState(null);
//   const [promotionOpen, setPromotionOpen] = useState(false);
//   const [selectedVariation, setSelectedVariation] = useState(null);
//   const [isMobile, setIsMobile] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [successPopup, setSuccessPopup] = useState(false);
//   const [errorPopup, setErrorPopup] = useState(false);
//   const [shareModalOpen, setShareModalOpen] = useState(false);
//   const [shareLinks, setShareLinks] = useState(null);

//   // ── Payment modal ───────────────────────────────────────
//   const [paymentOpen, setPaymentOpen] = useState(false);
//   const [freeExtensionOpen, setFreeExtensionOpen] = useState(false);
//   const [userId, setUserId] = useState(null);

//   // ── Upload limits ───────────────────────────────────────
//   const [uploadLimits, setUploadLimits] = useState(null);
//   const [limitsLoading, setLimitsLoading] = useState(true);

//   const navigate = useNavigate();

//   // ── Get userId from token ───────────────────────────────
//   const getUserId = () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       return JSON.parse(atob(token.split(".")[1])).id;
//     } catch {
//       return null;
//     }
//   };

//   // ── Count approved variations for tier detection ────────
//   const approvedCount = data.filter((v) => v.status === "approved").length;

//   useEffect(() => {
//     setUserId(getUserId());
//     fetchVariations();
//     fetchUploadLimits();
//   }, []);

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth <= 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   // ── API calls ───────────────────────────────────────────
//   const fetchVariations = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       const res = await axios.get(`${BASE_URL}/uservariations`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setData(res.data.variations || []);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchUploadLimits = async () => {
//     try {
//       setLimitsLoading(true);
//       const token = sessionStorage.getItem("token");
//       const res = await axios.get(`${BASE_URL}/uservariations/upload-limits`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (res.data.success) setUploadLimits(res.data.data);
//     } catch (err) {
//       console.error("Failed to fetch upload limits", err);
//     } finally {
//       setLimitsLoading(false);
//     }
//   };

//   const handleView = async (variationId) => {
//     try {
//       setViewModalOpen(true);
//       setViewData(null);
//       const token = sessionStorage.getItem("token");
//       const res = await axios.get(`${BASE_URL}/uservariations/${variationId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setViewData(res.data.variation);
//     } catch {
//       message.error("Failed to load variation details");
//       setViewModalOpen(false);
//     }
//   };

//   const handleDelete = async (id) => {
//     try {
//       await axios.delete(`${BASE_URL}/uservariations/${id}`, {
//         headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
//       });
//       setSuccessPopup(true);
//       fetchVariations();
//       fetchUploadLimits();
//     } catch {
//       setErrorPopup(true);
//     }
//   };

//   const handleShare = async (record) => {
//     try {
//       const token = sessionStorage.getItem("token");
//       const res = await axios.get(
//         `${BASE_URL}/promoteimgs/share-links/${record._id}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );
//       if (res.data.success) {
//         setShareLinks(res.data.data);
//         setShareModalOpen(true);
//       }
//     } catch {
//       message.error("Failed to get share links");
//     }
//   };

//   const openPromotion = (record) => {
//     setSelectedVariation(record);
//     setPromotionOpen(true);
//   };

//   // ── Upload Limits Card ──────────────────────────────────
//   const UploadLimitsCard = () => {
//     if (limitsLoading || !uploadLimits) return null;

//     if (uploadLimits.isPaidUser) {
//       return (
//         <Card
//           style={{
//             marginBottom: 16,
//             borderRadius: 12,
//             border: "1px solid #c7d2fe",
//             background: "linear-gradient(135deg, #eef2ff 0%, #f0fdf4 100%)",
//           }}
//           bodyStyle={{ padding: "14px 20px" }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <CrownOutlined style={{ fontSize: 22, color: "#4f46e5" }} />
//             <div>
//               <Text strong style={{ fontSize: 15, color: "#4f46e5" }}>
//                 Paid User — Unlimited Uploads
//               </Text>
//               <div style={{ fontSize: 12, color: "#6b7280" }}>
//                 No daily, weekly, or total upload limits apply to your account
//               </div>
//             </div>
//           </div>
//         </Card>
//       );
//     }

//     const { daily, weekly, total } = uploadLimits;

//     const getColor = (remaining, limit) => {
//       const pct = (remaining / limit) * 100;
//       if (pct <= 20) return "#ef4444";
//       if (pct <= 50) return "#f59e0b";
//       return "#10b981";
//     };

//     const LimitItem = ({ label, used, limit, remaining }) => (
//       <div style={{ textAlign: "center" }}>
//         <Text
//           type="secondary"
//           style={{ fontSize: 11, display: "block", marginBottom: 4 }}
//         >
//           {label}
//         </Text>
//         <Tooltip title={`${used} used / ${limit} total`}>
//           <Progress
//             type="circle"
//             percent={Math.round((used / limit) * 100)}
//             width={isMobile ? 64 : 72}
//             strokeColor={getColor(remaining, limit)}
//             format={() => (
//               <div style={{ lineHeight: 1.2 }}>
//                 <div
//                   style={{
//                     fontSize: isMobile ? 13 : 15,
//                     fontWeight: 700,
//                     color: getColor(remaining, limit),
//                   }}
//                 >
//                   {remaining}
//                 </div>
//                 <div style={{ fontSize: 10, color: "#9ca3af" }}>left</div>
//               </div>
//             )}
//           />
//         </Tooltip>
//         <Text
//           style={{
//             fontSize: 11,
//             color: "#6b7280",
//             display: "block",
//             marginTop: 4,
//           }}
//         >
//           {used}/{limit}
//         </Text>
//       </div>
//     );

//     return (
//       <Card
//         style={{
//           marginBottom: 16,
//           borderRadius: 12,
//           border: "1px solid #e5e7eb",
//         }}
//         bodyStyle={{ padding: "14px 20px" }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             flexWrap: "wrap",
//             gap: 12,
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//             <UploadOutlined style={{ fontSize: 18, color: "#6b7280" }} />
//             <div>
//               <Text strong style={{ fontSize: 14 }}>
//                 Upload Limits
//               </Text>
//               <div style={{ fontSize: 11, color: "#9ca3af" }}>
//                 Free account · Upgrade to remove limits
//               </div>
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               gap: isMobile ? 16 : 28,
//               alignItems: "center",
//             }}
//           >
//             <LimitItem
//               label="Today"
//               used={daily.used}
//               limit={daily.limit}
//               remaining={daily.remaining}
//             />
//             <LimitItem
//               label="This Week"
//               used={weekly.used}
//               limit={weekly.limit}
//               remaining={weekly.remaining}
//             />
//             <LimitItem
//               label="Total"
//               used={total.used}
//               limit={total.limit}
//               remaining={total.remaining}
//             />
//           </div>
//         </div>

//         {(daily.remaining === 0 ||
//           weekly.remaining === 0 ||
//           total.remaining === 0) && (
//           <div
//             style={{
//               marginTop: 10,
//               padding: "8px 12px",
//               background: "#fef2f2",
//               borderRadius: 6,
//               border: "1px solid #fecaca",
//               fontSize: 12,
//               color: "#dc2626",
//             }}
//           >
//             ⚠️{" "}
//             {daily.remaining === 0
//               ? "Daily limit reached. You can upload again tomorrow."
//               : weekly.remaining === 0
//                 ? "Weekly limit reached. You can upload again next week."
//                 : "Total upload limit reached. Upgrade to a paid plan for more uploads."}
//           </div>
//         )}
//       </Card>
//     );
//   };

//   // ── Table columns ───────────────────────────────────────
//   const columns = [
//     {
//       title: "Image",
//       dataIndex: "image",
//       render: (img) => (
//         <Image
//           src={img}
//           width={70}
//           height={70}
//           style={{ borderRadius: 8, objectFit: "cover" }}
//         />
//       ),
//     },
//     {
//       title: "Name",
//       dataIndex: "name",
//       render: (text) => <strong>{text}</strong>,
//     },
//     {
//       title: "Pose Type",
//       dataIndex: "poseType",
//       render: (types) =>
//         types?.map((t) => (
//           <Tag key={t} color="blue">
//             {t}
//           </Tag>
//         )),
//     },
//     {
//       title: "Status",
//       render: (_, record) =>
//         record.status === "pending" ? (
//           <Tag color="orange" icon={<LoadingOutlined />}>
//             Pending
//           </Tag>
//         ) : record.status === "rejected" ? (
//           <Tag color="red" icon={<CloseCircleFilled />}>
//             Rejected
//           </Tag>
//         ) : (
//           <Tag color="green" icon={<CheckCircleFilled />}>
//             Approved
//           </Tag>
//         ),
//     },
//     {
//       title: "Media Link",
//       dataIndex: "mediaLinkStatus",
//       render: (status) => (
//         <Tag color={status === "active" ? "green" : "orange"}>{status}</Tag>
//       ),
//     },
//     {
//       title: "Extension",
//       render: (_, record) =>
//         record.mediaLinkAction === "none" ? (
//           <Tag color="green">Free Trial</Tag>
//         ) : record?.mediaLinkAction === "completed" ||
//           record?.paymentStatus === "paid" ? (
//           <Tag color="purple">Renewal</Tag>
//         ) : (
//           <Button size="small" onClick={() => openPromotion(record)}>
//             Promote
//           </Button>
//         ),
//     },
//     {
//       title: "Actions",
//       render: (_, record) => (
//         <Space>
//           <Button
//             icon={<EyeOutlined />}
//             onClick={() => handleView(record._id)}
//           />
//           <Button
//             icon={<EditOutlined />}
//             type="primary"
//             onClick={() => navigate(`/user/edit-variation/${record._id}`)}
//           />
//           <Popconfirm
//             title="Delete this variation?"
//             onConfirm={() => handleDelete(record._id)}
//           >
//             <Button danger icon={<DeleteOutlined />} />
//           </Popconfirm>
//           {record.status === "approved" && (
//             <Button
//               icon={<ShareAltOutlined />}
//               onClick={() => handleShare(record)}
//               style={{
//                 background: "#10b981",
//                 color: "#fff",
//                 borderColor: "#10b981",
//               }}
//             >
//               Share
//             </Button>
//           )}
//         </Space>
//       ),
//     },
//   ];

//   // ── Mobile card ─────────────────────────────────────────
//   const MobileVariationCard = ({ record }) => {
//     const isFreeTrial = record.mediaLinkAction === "none";
//     const isRenewal =
//       record.mediaLinkAction === "completed" || record.paymentStatus === "paid";

//     return (
//       <Card
//         style={{
//           marginBottom: 16,
//           borderRadius: 16,
//           boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
//         }}
//         bodyStyle={{ padding: 14 }}
//       >
//         <div style={{ display: "flex", gap: 12 }}>
//           <Image
//             src={record.image}
//             width={70}
//             height={70}
//             style={{ borderRadius: 10, objectFit: "cover" }}
//           />
//           <div style={{ flex: 1 }}>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//               }}
//             >
//               <div style={{ fontWeight: 600, fontSize: 16 }}>{record.name}</div>
//               <Tag
//                 color={
//                   record.status === "approved"
//                     ? "green"
//                     : record.status === "rejected"
//                       ? "red"
//                       : "orange"
//                 }
//               >
//                 {record.status}
//               </Tag>
//             </div>
//             <div style={{ fontSize: 13, color: "#777" }}>
//               {record.poseType?.join(", ")}
//             </div>
//             <div style={{ marginTop: 6 }}>
//               <Tag
//                 color={record.mediaLinkStatus === "active" ? "green" : "orange"}
//               >
//                 {record.mediaLinkStatus}
//               </Tag>
//             </div>
//           </div>
//         </div>

//         <div style={{ marginTop: 10 }}>
//           {isFreeTrial && <Tag color="green">Free Trial</Tag>}
//           {isRenewal && <Tag color="purple">Renewal</Tag>}
//           {!isFreeTrial && !isRenewal && (
//             <Button size="small" onClick={() => openPromotion(record)}>
//               Promote
//             </Button>
//           )}
//         </div>

//         <div
//           style={{
//             marginTop: 14,
//             display: "flex",
//             justifyContent: "flex-end",
//             gap: 10,
//           }}
//         >
//           <Button
//             icon={<EyeOutlined />}
//             onClick={() => handleView(record._id)}
//           />
//           <Button
//             icon={<EditOutlined />}
//             onClick={() => navigate(`/user/edit-variation/${record._id}`)}
//           />
//           <Popconfirm
//             title="Delete?"
//             onConfirm={() => handleDelete(record._id)}
//           >
//             <Button danger icon={<DeleteOutlined />} />
//           </Popconfirm>
//           {record.status === "approved" && (
//             <Button
//               icon={<ShareAltOutlined />}
//               onClick={() => handleShare(record)}
//               style={{
//                 background: "#10b981",
//                 color: "#fff",
//                 borderColor: "#10b981",
//               }}
//             />
//           )}
//         </div>
//       </Card>
//     );
//   };

//   // ── Render ──────────────────────────────────────────────
//   return (
//     <div>
//       <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
//         <Sidebar
//           collapsed={collapsed}
//           setCollapsed={setCollapsed}
//           mobileOpen={mobileOpen}
//           setMobileOpen={setMobileOpen}
//           isMobile={isMobile}
//           collapsedWidth="0"
//           role="user"
//         />
//         <Layout
//           className="main-layout"
//           style={{
//             marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
//             transition: "0.3s",
//             padding: isMobile ? 10 : 20,
//           }}
//         >
//           <Header className="MainHeader">
//             {isMobile && (
//               <Button
//                 type="text"
//                 icon={<MenuOutlined />}
//                 onClick={() => setMobileOpen(true)}
//                 style={{ fontSize: 18, marginRight: 12 }}
//               />
//             )}
//             <div style={{ flex: 1 }}>
//               <Text style={{ fontSize: 20, fontWeight: "bold" }}>
//                 My Variations
//               </Text>
//             </div>
//             {/* ── Global Extend Plan button ── */}
//             <Space>
//               <Button
//                 size="large"
//                 onClick={() => setFreeExtensionOpen(true)}
//                 style={{
//                   background: "#10b981",
//                   borderColor: "#10b981",
//                   color: "#fff",
//                 }}
//               >
//                  Free Extension
//               </Button>
//               <Button
//                 type="primary"
//                 size="large"
//                 onClick={() => setPaymentOpen(true)}
//                 style={{ background: "#4f46e5", borderColor: "#4f46e5" }}
//               >
//                 Extend / Upgrade Plan
//               </Button>
//             </Space>
//           </Header>

//           {/* Upload limits */}
//           <UploadLimitsCard />

//           {/* Variations table / cards */}
//           <Card style={{ width: "100%" }}>
//             {isMobile ? (
//               data.map((record) => (
//                 <MobileVariationCard key={record._id} record={record} />
//               ))
//             ) : (
//               <Table
//                 columns={columns}
//                 dataSource={data}
//                 rowKey="_id"
//                 loading={loading}
//               />
//             )}
//           </Card>

//           {/* View Modal */}
//           <Modal
//             title="Variation Details"
//             open={viewModalOpen}
//             onCancel={() => setViewModalOpen(false)}
//             footer={null}
//             width={900}
//             centered
//           >
//             {viewData && (
//               <Descriptions bordered column={1}>
//                 <Descriptions.Item label="Name">
//                   {viewData.name}
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Sanskrit">
//                   {viewData.sanskrit}
//                 </Descriptions.Item>
//                 <Descriptions.Item label="English">
//                   {viewData.english}
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Pose Type">
//                   {viewData.poseType?.join(", ")}
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Media Link">
//                   <a href={viewData.mediaLink} target="_blank" rel="noreferrer">
//                     {viewData.mediaLink}
//                   </a>
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Image">
//                   <Image src={viewData.image} width={260} />
//                 </Descriptions.Item>
//               </Descriptions>
//             )}
//           </Modal>

//           {/* Share Modal */}
//           <Modal
//             title="Share this image"
//             open={shareModalOpen}
//             onCancel={() => setShareModalOpen(false)}
//             footer={null}
//             centered
//           >
//             {shareLinks && (
//               <Space direction="vertical" style={{ width: "100%" }}>
//                 <Button
//                   block
//                   href={shareLinks.facebook}
//                   target="_blank"
//                   style={{
//                     background: "#1877f2",
//                     color: "#fff",
//                     borderColor: "#1877f2",
//                   }}
//                 >
//                   Share on Facebook
//                 </Button>
//                 <Button
//                   block
//                   href={shareLinks.twitter}
//                   target="_blank"
//                   style={{
//                     background: "#1da1f2",
//                     color: "#fff",
//                     borderColor: "#1da1f2",
//                   }}
//                 >
//                   Share on Twitter
//                 </Button>
//                 <Button
//                   block
//                   href={shareLinks.whatsapp}
//                   target="_blank"
//                   style={{
//                     background: "#25d366",
//                     color: "#fff",
//                     borderColor: "#25d366",
//                   }}
//                 >
//                   Share on WhatsApp
//                 </Button>
//                 <Button
//                   block
//                   href={shareLinks.instagram}
//                   target="_blank"
//                   style={{
//                     background: "#e1306c",
//                     color: "#fff",
//                     borderColor: "#e1306c",
//                   }}
//                 >
//                   Open Instagram
//                 </Button>
//               </Space>
//             )}
//           </Modal>
//         </Layout>
//       </Layout>

//       {/* Payment Modal — reuses same component as MainDashboard */}
//       <PaymentModal
//         open={paymentOpen}
//         onClose={() => setPaymentOpen(false)}
//         userId={userId}
//         userMediaLinkCount={approvedCount}
//         onSuccess={() => {
//           fetchVariations();
//           fetchUploadLimits();
//         }}
//       />

//       <FreeExtensionModal
//         open={freeExtensionOpen}
//         onClose={() => setFreeExtensionOpen(false)}
//         onSuccess={() => {
//           fetchVariations();
//           fetchUploadLimits();
//         }}
//       />

//       <PromotionPopup
//         open={promotionOpen}
//         onClose={() => setPromotionOpen(false)}
//         variation={selectedVariation}
//       />

//       <SuccessPopup
//         open={successPopup}
//         message="Variation deleted successfully!"
//         onClose={() => setSuccessPopup(false)}
//       />

//       <ErrorPopup
//         open={errorPopup}
//         setOpen={setErrorPopup}
//         message="Variation delete failed"
//       />
//     </div>
//   );
// };

// export default MyVariations;


import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Space,
  Image,
  Popconfirm,
  message,
  Card,
  Tag,
  Modal,
  Descriptions,
  Layout,
  Typography,
  Progress,
  Tooltip,
  Avatar,
  Divider,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
  LoadingOutlined,
  CrownOutlined,
  UploadOutlined,
  MenuOutlined,
  ShareAltOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import { BASE_URL } from "../Config";
import axios from "axios";
import ErrorPopup from "../Components/popup/ErrorPopup";
import SuccessPopup from "../Components/popup/SuccessPopup";
import PromotionPopup from "../Components/popup/PromotionPopup/PromotionPopup";
import PaymentModal from "../Components/PaymentModal";
import FreeExtensionModal from "../Components/FreeExtensionModal";

const { Content } = Layout;
const { Text, Title } = Typography;

const MyVariations = () => {
  const [data, setData] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [promotionOpen, setPromotionOpen] = useState(false);
  const [selectedVariation, setSelectedVariation] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [shareLinks, setShareLinks] = useState(null);

  const [paymentOpen, setPaymentOpen] = useState(false);
  const [freeExtensionOpen, setFreeExtensionOpen] = useState(false);
  const [userId, setUserId] = useState(null);

  const [uploadLimits, setUploadLimits] = useState(null);
  const [limitsLoading, setLimitsLoading] = useState(true);

  const navigate = useNavigate();

  const getUserId = () => {
    try {
      const token = sessionStorage.getItem("token");
      return JSON.parse(atob(token.split(".")[1])).id;
    } catch {
      return null;
    }
  };

  const approvedCount = data.filter((v) => v.status === "approved").length;

  useEffect(() => {
    setUserId(getUserId());
    fetchVariations();
    fetchUploadLimits();
  }, []);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const fetchVariations = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/uservariations`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(res.data.variations || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchUploadLimits = async () => {
    try {
      setLimitsLoading(true);
      const token = sessionStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/uservariations/upload-limits`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) setUploadLimits(res.data.data);
    } catch (err) {
      console.error("Failed to fetch upload limits", err);
    } finally {
      setLimitsLoading(false);
    }
  };

  const handleView = async (variationId) => {
    try {
      setViewModalOpen(true);
      setViewData(null);
      const token = sessionStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/uservariations/${variationId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setViewData(res.data.variation);
    } catch {
      message.error("Failed to load variation details");
      setViewModalOpen(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/uservariations/${id}`, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      });
      setSuccessPopup(true);
      fetchVariations();
      fetchUploadLimits();
    } catch {
      setErrorPopup(true);
    }
  };

  const handleShare = async (record) => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await axios.get(
        `${BASE_URL}/promoteimgs/share-links/${record._id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        setShareLinks(res.data.data);
        setShareModalOpen(true);
      }
    } catch {
      message.error("Failed to get share links");
    }
  };

  const openPromotion = (record) => {
    setSelectedVariation(record);
    setPromotionOpen(true);
  };

  // ── Upload Limits Card ──────────────────────────────────
  const UploadLimitsCard = () => {
    if (limitsLoading || !uploadLimits) return null;

    if (uploadLimits.isPaidUser) {
      return (
        <Card
          style={{
            marginBottom: 16,
            borderRadius: 12,
            border: "1px solid #c7d2fe",
            background: "linear-gradient(135deg, #eef2ff 0%, #f0fdf4 100%)",
          }}
          bodyStyle={{ padding: "14px 16px" }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <CrownOutlined style={{ fontSize: 22, color: "#4f46e5" }} />
            <div>
              <Text strong style={{ fontSize: 15, color: "#4f46e5" }}>
                Paid User — Unlimited Uploads
              </Text>
              <div style={{ fontSize: 12, color: "#6b7280" }}>
                No daily, weekly, or total upload limits apply
              </div>
            </div>
          </div>
        </Card>
      );
    }

    const { daily, weekly, total } = uploadLimits;

    const getColor = (remaining, limit) => {
      const pct = (remaining / limit) * 100;
      if (pct <= 20) return "#ef4444";
      if (pct <= 50) return "#f59e0b";
      return "#10b981";
    };

    const LimitItem = ({ label, used, limit, remaining }) => (
      <div style={{ textAlign: "center", flex: 1 }}>
        <Text type="secondary" style={{ fontSize: 11, display: "block", marginBottom: 6 }}>
          {label}
        </Text>
        <Tooltip title={`${used} used / ${limit} total`}>
          <Progress
            type="circle"
            percent={Math.round((used / limit) * 100)}
            width={isMobile ? 60 : 72}
            strokeColor={getColor(remaining, limit)}
            format={() => (
              <div style={{ lineHeight: 1.2 }}>
                <div style={{ fontSize: isMobile ? 13 : 15, fontWeight: 700, color: getColor(remaining, limit) }}>
                  {remaining}
                </div>
                <div style={{ fontSize: 10, color: "#9ca3af" }}>left</div>
              </div>
            )}
          />
        </Tooltip>
        <Text style={{ fontSize: 11, color: "#6b7280", display: "block", marginTop: 4 }}>
          {used}/{limit}
        </Text>
      </div>
    );

    return (
      <Card
        style={{ marginBottom: 16, borderRadius: 12, border: "1px solid #e5e7eb" }}
        bodyStyle={{ padding: "14px 16px" }}
      >
        {/* Header row */}
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
          <UploadOutlined style={{ fontSize: 18, color: "#6b7280" }} />
          <div>
            <Text strong style={{ fontSize: 14 }}>Upload Limits</Text>
            <div style={{ fontSize: 11, color: "#9ca3af" }}>
              Free account · Upgrade to remove limits
            </div>
          </div>
        </div>

        {/* Gauges — always in a full-width row */}
        <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center" }}>
          <LimitItem label="Today"     used={daily.used}   limit={daily.limit}   remaining={daily.remaining} />
          <LimitItem label="This Week" used={weekly.used}  limit={weekly.limit}  remaining={weekly.remaining} />
          <LimitItem label="Total"     used={total.used}   limit={total.limit}   remaining={total.remaining} />
        </div>

        {(daily.remaining === 0 || weekly.remaining === 0 || total.remaining === 0) && (
          <div style={{
            marginTop: 12,
            padding: "8px 12px",
            background: "#fef2f2",
            borderRadius: 6,
            border: "1px solid #fecaca",
            fontSize: 12,
            color: "#dc2626",
          }}>
            ⚠️{" "}
            {daily.remaining === 0
              ? "Daily limit reached. You can upload again tomorrow."
              : weekly.remaining === 0
              ? "Weekly limit reached. You can upload again next week."
              : "Total upload limit reached. Upgrade to a paid plan for more uploads."}
          </div>
        )}
      </Card>
    );
  };

  // ── Table columns (desktop) ─────────────────────────────
  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      render: (img) => (
        <Image src={img} width={70} height={70} style={{ borderRadius: 8, objectFit: "cover" }} />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Pose Type",
      dataIndex: "poseType",
      render: (types) => types?.map((t) => <Tag key={t} color="blue">{t}</Tag>),
    },
    {
      title: "Status",
      render: (_, record) =>
        record.status === "pending" ? (
          <Tag color="orange" icon={<LoadingOutlined />}>Pending</Tag>
        ) : record.status === "rejected" ? (
          <Tag color="red" icon={<CloseCircleFilled />}>Rejected</Tag>
        ) : (
          <Tag color="green" icon={<CheckCircleFilled />}>Approved</Tag>
        ),
    },
    {
      title: "Media Link",
      dataIndex: "mediaLinkStatus",
      render: (status) => (
        <Tag color={status === "active" ? "green" : "orange"}>{status}</Tag>
      ),
    },
    {
      title: "Extension",
      render: (_, record) =>
        record.mediaLinkAction === "none" ? (
          <Tag color="green">Free Trial</Tag>
        ) : record?.mediaLinkAction === "completed" || record?.paymentStatus === "paid" ? (
          <Tag color="purple">Renewal</Tag>
        ) : (
          <Button size="small" onClick={() => openPromotion(record)}>Promote</Button>
        ),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Button icon={<EyeOutlined />} onClick={() => handleView(record._id)} />
          <Button icon={<EditOutlined />} type="primary" onClick={() => navigate(`/user/edit-variation/${record._id}`)} />
          <Popconfirm title="Delete this variation?" onConfirm={() => handleDelete(record._id)}>
            <Button danger icon={<DeleteOutlined />} />
          </Popconfirm>
          {record.status === "approved" && (
            <Button
              icon={<ShareAltOutlined />}
              onClick={() => handleShare(record)}
              style={{ background: "#10b981", color: "#fff", borderColor: "#10b981" }}
            >
              Share
            </Button>
          )}
        </Space>
      ),
    },
  ];

  // ── Mobile variation card ───────────────────────────────
  const MobileVariationCard = ({ record }) => {
    const isFreeTrial = record.mediaLinkAction === "none";
    const isRenewal = record.mediaLinkAction === "completed" || record.paymentStatus === "paid";
    const statusColor = record.status === "approved" ? "green" : record.status === "rejected" ? "red" : "orange";

    return (
      <Card
        style={{
          marginBottom: 12,
          borderRadius: 16,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          border: "1px solid #f0f0f0",
        }}
        bodyStyle={{ padding: 14 }}
      >
        {/* Top row: image + info */}
        <div style={{ display: "flex", gap: 12 }}>
          <Image
            src={record.image}
            width={72}
            height={72}
            style={{ borderRadius: 10, objectFit: "cover", flexShrink: 0 }}
          />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 6 }}>
              <Text strong style={{ fontSize: 15, flex: 1 }} ellipsis>{record.name}</Text>
              <Tag color={statusColor} style={{ textTransform: "capitalize", flexShrink: 0 }}>
                {record.status}
              </Tag>
            </div>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {record.poseType?.join(", ")}
            </Text>
            <div style={{ marginTop: 6, display: "flex", gap: 6, flexWrap: "wrap" }}>
              <Tag color={record.mediaLinkStatus === "active" ? "green" : "orange"} style={{ margin: 0 }}>
                {record.mediaLinkStatus}
              </Tag>
              {isFreeTrial && <Tag color="green" style={{ margin: 0 }}>Free Trial</Tag>}
              {isRenewal && <Tag color="purple" style={{ margin: 0 }}>Renewal</Tag>}
              {!isFreeTrial && !isRenewal && (
                <Button size="small" onClick={() => openPromotion(record)}>Promote</Button>
              )}
            </div>
          </div>
        </div>

        <Divider style={{ margin: "12px 0 10px" }} />

        {/* Action buttons */}
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <Button
            icon={<EyeOutlined />}
            size="middle"
            onClick={() => handleView(record._id)}
          />
          <Button
            icon={<EditOutlined />}
            size="middle"
            type="primary"
            style={{ background: "#4f46e5", borderColor: "#4f46e5" }}
            onClick={() => navigate(`/user/edit-variation/${record._id}`)}
          />
          <Popconfirm title="Delete this variation?" onConfirm={() => handleDelete(record._id)}>
            <Button danger icon={<DeleteOutlined />} size="middle" />
          </Popconfirm>
          {record.status === "approved" && (
            <Button
              icon={<ShareAltOutlined />}
              size="middle"
              onClick={() => handleShare(record)}
              style={{ background: "#10b981", color: "#fff", borderColor: "#10b981" }}
            />
          )}
        </div>
      </Card>
    );
  };

  // ── Empty state ─────────────────────────────────────────
  const EmptyState = () => (
    <div style={{ textAlign: "center", padding: "48px 24px" }}>
      <Avatar
        size={72}
        icon={<PictureOutlined />}
        style={{ background: "#ede9fe", color: "#7c3aed", marginBottom: 16 }}
      />
      <Title level={5} style={{ color: "#6b7280" }}>No variations yet</Title>
      <Text type="secondary" style={{ fontSize: 13 }}>
        Upload your first image to get started
      </Text>
      <div style={{ marginTop: 16 }}>
        <Button
          type="primary"
          style={{ background: "#7c3aed", borderColor: "#7c3aed" }}
          onClick={() => navigate("/user-page")}
        >
          Upload Now
        </Button>
      </div>
    </div>
  );

  // ── Render ──────────────────────────────────────────────
  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        collapsedWidth="0"
        role="user"
      />

      <Layout
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
          transition: "margin 0.3s",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        {/* ── Mobile sticky header ── */}
        {isMobile ? (
          <div
            style={{
              position: "sticky",
              top: 0,
              zIndex: 100,
              background: "#fff",
              borderBottom: "1px solid #f0f0f0",
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            }}
          >
            {/* Row 1: hamburger + title */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                padding: "12px 16px 8px",
              }}
            >
              <Button
                type="text"
                icon={<MenuOutlined style={{ fontSize: 20 }} />}
                onClick={() => setMobileOpen(true)}
                style={{
                  width: 40,
                  height: 40,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 8,
                  background: "#f5f3ff",
                  color: "#7c3aed",
                  border: "none",
                  flexShrink: 0,
                }}
              />
              <Text strong style={{ fontSize: 17, color: "#1e1b4b", flex: 1 }}>
                My Variations
              </Text>
            </div>

            {/* Row 2: action buttons full-width */}
            <div
              style={{
                display: "flex",
                gap: 8,
                padding: "0 16px 12px",
              }}
            >
              <Button
                block
                onClick={() => setFreeExtensionOpen(true)}
                style={{
                  background: "#10b981",
                  borderColor: "#10b981",
                  color: "#fff",
                  borderRadius: 8,
                  fontWeight: 600,
                  height: 40,
                  fontSize: 13,
                }}
              >
                 Free Extension
              </Button>
              <Button
                block
                type="primary"
                onClick={() => setPaymentOpen(true)}
                style={{
                  background: "#4f46e5",
                  borderColor: "#4f46e5",
                  borderRadius: 8,
                  fontWeight: 600,
                  height: 40,
                  fontSize: 13,
                }}
              >
                Upgrade Plan
              </Button>
            </div>
          </div>
        ) : (
          /* ── Desktop header ── */
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "16px 24px",
              background: "#fff",
              borderBottom: "1px solid #f0f0f0",
              boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
            }}
          >
            <Title level={4} style={{ margin: 0, color: "#1e1b4b" }}>
              My Variations
            </Title>
            <Space>
              <Button
                size="large"
                onClick={() => setFreeExtensionOpen(true)}
                style={{ background: "#10b981", borderColor: "#10b981", color: "#fff" }}
              >
                 Free Extension
              </Button>
              <Button
                type="primary"
                size="large"
                onClick={() => setPaymentOpen(true)}
                style={{ background: "#4f46e5", borderColor: "#4f46e5" }}
              >
                Extend / Upgrade Plan
              </Button>
            </Space>
          </div>
        )}

        {/* ── Page content ── */}
        <Content style={{ padding: isMobile ? 12 : 24, flex: 1 }}>

          {/* Upload limits */}
          <UploadLimitsCard />

          {/* Variations list */}
          <Card
            style={{ borderRadius: 16, overflow: "hidden" }}
            bodyStyle={{ padding: isMobile ? 12 : 24 }}
          >
            {loading ? (
              <div style={{ textAlign: "center", padding: 40 }}>
                <LoadingOutlined style={{ fontSize: 32, color: "#7c3aed" }} />
              </div>
            ) : data.length === 0 ? (
              <EmptyState />
            ) : isMobile ? (
              data.map((record) => (
                <MobileVariationCard key={record._id} record={record} />
              ))
            ) : (
              <Table
                columns={columns}
                dataSource={data}
                rowKey="_id"
                loading={loading}
                scroll={{ x: 900 }}
              />
            )}
          </Card>
        </Content>

        {/* Footer */}
        <div
          style={{
            textAlign: "center",
            padding: "16px",
            color: "#aaa",
            fontSize: 13,
            borderTop: "1px solid #f0f0f0",
            background: "#fff",
          }}
        >
          © 2026 YogaRefer.Com | All rights reserved
        </div>
      </Layout>

      {/* ── Modals ── */}
      <Modal
        title="Variation Details"
        open={viewModalOpen}
        onCancel={() => setViewModalOpen(false)}
        footer={null}
        width={isMobile ? "95vw" : 900}
        centered
      >
        {viewData && (
          <Descriptions bordered column={1}>
            <Descriptions.Item label="Name">{viewData.name}</Descriptions.Item>
            <Descriptions.Item label="Sanskrit">{viewData.sanskrit}</Descriptions.Item>
            <Descriptions.Item label="English">{viewData.english}</Descriptions.Item>
            <Descriptions.Item label="Pose Type">{viewData.poseType?.join(", ")}</Descriptions.Item>
            <Descriptions.Item label="Media Link">
              <a href={viewData.mediaLink} target="_blank" rel="noreferrer">{viewData.mediaLink}</a>
            </Descriptions.Item>
            <Descriptions.Item label="Image">
              <Image src={viewData.image} width={isMobile ? 180 : 260} />
            </Descriptions.Item>
          </Descriptions>
        )}
      </Modal>

      <Modal
        title="Share this image"
        open={shareModalOpen}
        onCancel={() => setShareModalOpen(false)}
        footer={null}
        centered
        width={isMobile ? "92vw" : 480}
      >
        {shareLinks && (
          <Space direction="vertical" style={{ width: "100%" }}>
            <Button block href={shareLinks.facebook} target="_blank"
              style={{ background: "#1877f2", color: "#fff", borderColor: "#1877f2", height: 44, fontWeight: 600 }}>
              Share on Facebook
            </Button>
            <Button block href={shareLinks.twitter} target="_blank"
              style={{ background: "#1da1f2", color: "#fff", borderColor: "#1da1f2", height: 44, fontWeight: 600 }}>
              Share on Twitter
            </Button>
            <Button block href={shareLinks.whatsapp} target="_blank"
              style={{ background: "#25d366", color: "#fff", borderColor: "#25d366", height: 44, fontWeight: 600 }}>
              Share on WhatsApp
            </Button>
            <Button block href={shareLinks.instagram} target="_blank"
              style={{ background: "#e1306c", color: "#fff", borderColor: "#e1306c", height: 44, fontWeight: 600 }}>
              Open Instagram
            </Button>
          </Space>
        )}
      </Modal>

      <PaymentModal
        open={paymentOpen}
        onClose={() => setPaymentOpen(false)}
        userId={userId}
        userMediaLinkCount={approvedCount}
        onSuccess={() => { fetchVariations(); fetchUploadLimits(); }}
      />
      <FreeExtensionModal
        open={freeExtensionOpen}
        onClose={() => setFreeExtensionOpen(false)}
        onSuccess={() => { fetchVariations(); fetchUploadLimits(); }}
      />
      <PromotionPopup
        open={promotionOpen}
        onClose={() => setPromotionOpen(false)}
        variation={selectedVariation}
      />
      <SuccessPopup
        open={successPopup}
        message="Variation deleted successfully!"
        onClose={() => setSuccessPopup(false)}
      />
      <ErrorPopup
        open={errorPopup}
        setOpen={setErrorPopup}
        message="Variation delete failed"
      />
    </Layout>
  );
};

export default MyVariations;